// Per-realm styling resources — HitFit and NiksFit run the same office app codebase as two
// separately-branded gyms, differing only in things like logo/colors. REACT_APP_REALM (.env)
// picks which brand's assets this build/session loads; defaults to "hitfit" so an unset env
// var (existing deployments) keeps working as before. Add more per-realm resources (colors,
// other images) the same way: one file per brand folder, looked up through REALM here.
import hitfitLogo from "./hitfit/logo.png";
import niksfitLogo from "./niksfit/logo.png";
import hitfitAppLogo from "./hitfit/app_logo.png";
import niksfitAppLogo from "./niksfit/app_logo.png";

export const REALM = process.env.REACT_APP_REALM || "hitfit";

const LOGOS = {
  hitfit: hitfitLogo,
  niksfit: niksfitLogo,
};

// The sidebar/header wordmark (AppShell) — separate from `logo` (the square PWA/manifest
// icon) since the two are shaped completely differently and were already two different files
// per brand (hitfit-logo-transparent.png vs logo512.png) before this folder existed.
const APP_LOGOS = {
  hitfit: hitfitAppLogo,
  niksfit: niksfitAppLogo,
};

export const logo = LOGOS[REALM] || LOGOS.hitfit;
export const appLogo = APP_LOGOS[REALM] || APP_LOGOS.hitfit;
